import React from "react";
import { Typography } from "../../../components";
import {
  SubscribeTitle,
  SubscribeContainer,
  SubscribeForm,
  SubscribeInputWrap,
  SubscribeInput,
  SubscribeButton,
  SubscribeIcon,
} from "./subscribeElements";
import { FaPaperPlane } from "react-icons/fa";
import useSubscribe from "../../../hooks/useSubscribe";
import { useMutation } from "react-query";
import useForm from "../../../hooks/useForm";
import { ErrorText } from "../../signIn/signInElements";
import validate from "../../../utilities/validate";
import ClipLoader from "react-spinners/ClipLoader";
import Alert from "@material-ui/lab/Alert";

const formData = [
  {
    name: "emailAddress",
    label: "Email Address",
    placeholder: "Enter Your Email Address",
    type: "email",
    value: "",
    required: true,
  },
];
export default () => {
  const { values, handleChange } = useForm(formData);
  const [formErrors, setFormErrors] = React.useState({});
  const [successMessage, setSuccessMessage] = React.useState("");

  const [mutateSubscribe, { isLoading }] = useMutation(useSubscribe, {
    onSuccess: (response) => {
      setSuccessMessage(response.message);
      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);
    },
    onError: () => {
      alert("Something went wrong");
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormErrors({});
    setSuccessMessage("");

    const tempErrors = validate(values);

    if (Object.keys(tempErrors).length) {
      setFormErrors(tempErrors);
    } else {
      mutateSubscribe({
        email: values[0].value,
      });
    }
  };

  return (
    <SubscribeContainer>
      <SubscribeTitle>
        <Typography h2>Subscribe To Our Newsletter</Typography>
      </SubscribeTitle>
      <Typography body1>
        Please subscribe to our newsletter to get the latest updates in your
        email and stay
      </Typography>
      <Typography body1>connected with us.</Typography>
      {successMessage && <Alert severity="success">{successMessage}</Alert>}
      <SubscribeForm onSubmit={handleSubmit}>
        {values.map(({ placeholder, type, value, name }) => (
          <SubscribeInputWrap key={name}>
            <SubscribeInput
              name={name}
              type={type}
              placeholder={placeholder}
              value={value}
              onChange={handleChange}
            />
            {<ErrorText>{formErrors[name]}</ErrorText>}
          </SubscribeInputWrap>
        ))}
        <SubscribeButton disabled={isLoading}>
          {isLoading ? (
            <ClipLoader size={28} color="#fff" loading={true} />
          ) : (
            <>
              <SubscribeIcon>
                <FaPaperPlane />
              </SubscribeIcon>
              <Typography h3 color="#fff">
                Subscribe
              </Typography>
            </>
          )}
        </SubscribeButton>
      </SubscribeForm>
    </SubscribeContainer>
  );
};
